//import { useState, useEffect } from 'react';
import axios from 'axios';

const { REACT_APP_API_URL } = process.env;

const Request = async (props) => {

	// mocks an api call
	if (props.test){
		return new Promise(resolve => {
			const data = props.test;
			setTimeout(() => {
			  resolve({data:data});
			}, Math.random() * 20);
		});
	}

	let qs="";
	if (!props.method || props.method==="GET"){
		if (props.data){
			let params={...props.data};
			delete params['id'];
			if (params){
				qs=Object.keys(params).map(key => key + '=' + params[key]).join('&');
				if (qs) props.url+="?"+qs;
			}
		}
	}

	//const api_key=localStorage.getItem("___identity");

	// regular api calls
	const client = axios.create({
		...props.config,
		baseURL: REACT_APP_API_URL ?? "",
		headers: props.headers || {
			'Content-Type': 'application/json',
			Accept: 'application/json',
			//Authorization: `Bearer ${api_key}`,
		},
		method: props.method || "GET",
		data: props.data || {},
		responseType: props.responseType || "json",
		timeout: 100000
	});	

	const onSuccess = (response) => {
		return Promise.resolve(response.data);
  	}

  	const onError = (error) => {
		let errordata={
			message: "An error ocurred.",
			request: error.config
		};

		//console.log("err",error.response);

		if (error.response) {
			errordata={
				...errordata,
				status: error.response.status,
				data: error.response.data,
				headers: error.response.headers
			}
		} else errordata.message=error.message;

		return Promise.reject(errordata);
	}

  	try {
		const response = await client({...props});
		return onSuccess(response);
	} catch (error) {
		return onError(error);
	}
}

export default Request;